import CheckBox from "@app/sharedComponents/CheckBox/CheckBox";
import { PencilSimple } from "@app/sharedComponents/Icons/Icons";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import Edit from '../../../assets/Icons/Edit';
import { useState } from "react";
import { TouchableOpacity } from "react-native";
import Modal from "react-native-modal";
import Info from "../../../assets/Icons/Info";


const PleadegedAssetInfo = ({key,position,asset,isEdit=false, onCheckboxPressed, pledgedList, onEditAmountPressed, showCreditLimit = true , showLimitFullWarning= false, boxIndex = 0, isViewOnly = false})=>{
    const {assetName,assetCurrentLimit,assetPledgedValue} = asset
    const [isChecked, setIsChecked] = useState(false)
    console.log("KEY",position)
    

 const isAssetPledged  = () => {
    const isPledged = pledgedList.find((pledgedAsset) => pledgedAsset.unique_locator === asset.unique_locator)
    return isPledged ? true : false

 }

  const handleCheckBox = ()=>{  
    setIsChecked(!isChecked)
    console.log("CHECKBOX",position)
    onCheckboxPressed(asset)
  } 

  

    return(
        <ThemedView>
            <ThemedView flexDirection="row" justifyContent="space-between" >
                <ThemedView flex={2} flexDirection="row">
                    {isEdit && <ThemedPressable mt="xs" hitSlop={15}>
                    <CheckBox
                            size={20}
                            onToggle={()=>{
                                handleCheckBox()
                            }}
                            isChecked={isAssetPledged()}
                        />
                    </ThemedPressable>}
                    <ThemedText  variant="b3r" color="text-primary" mr="xs" flexShrink={1}>{assetName}</ThemedText>
                </ThemedView>
                { showCreditLimit && <ThemedView flex={1} flexDirection="row" justifyContent="flex-end">
                    <ThemedText textAlign="right" variant="b1s" color="text-emphasis-secondary" ml="lg">{`₹${formatIndianCurrency(parseInt(isViewOnly ?assetCurrentLimit : assetPledgedValue))}`}</ThemedText>
                    {isEdit &&
                    <ThemedPressable marginLeft="sm" mt="xs" onPress={()=> {
                        onEditAmountPressed(asset, position)
                          
                                                   
                    }}>
                   <Edit size={16} />
                    </ThemedPressable>}
                </ThemedView>}
            </ThemedView>
           {showCreditLimit && !isViewOnly && <ThemedText ml={isEdit ? "xl" :"2xs"} variant="b4r" color="text-secondary">Limit: ₹{formatIndianCurrency(assetCurrentLimit)}</ThemedText>}
           {showCreditLimit && isViewOnly && <ThemedText ml={isEdit ? "xl" :"2xs"} variant="b4r" color="text-secondary">Value: ₹{formatIndianCurrency(assetPledgedValue)}</ThemedText>}

           {showLimitFullWarning && boxIndex === position && <ThemedView flexDirection="row" marginTop="sm" padding="sm" backgroundColor="bg-fill-warning">
             <Info size={16}  />
             <ThemedText variant="b4r"> Selected fund value adjusted based on your available limit and dues.</ThemedText>
              </ThemedView>}
            <ThemedView height={1} backgroundColor="border-primary" width="100%" my="lg" />

        </ThemedView>
    )
}
export default PleadegedAssetInfo;